<template>
  <div v-if="showAlert" class="container-fluid pt-3">
    <div class="row">
      <div class="col-12">
        <ArgonAlert color="warning" textSize="sm">
          {{ $t("General.ResourceNotConnectedAlert.Message") }}
          <router-link :to="'/resources/' + current_bot.key + '/edit'" class="btn m-0 btn-light btn-sm ms-3">
            {{ $t("General.ResourceNotConnectedAlert.Action") }}
          </router-link>
        </ArgonAlert>
      </div>
    </div>
  </div>
</template>

<script>
import ArgonAlert from "@/components/ArgonAlert.vue";

// Mirrors common\models\UserBots::STATUS_* on the backend.
const STATUS_ON = 1;
const STATUS_CONNECTING = 5;

export default {
  name: "ResourceNotConnectedAlert",
  components: { ArgonAlert },
  computed: {
    current_bot() {
      return this.$store.state.init.current_bot
    },
    currentBotStatus() {
      return this.$store.state.init?.user_bots[this.current_bot?.key]?.status
    },
    showAlert() {
      // Anything that isn't ON (or briefly CONNECTING) means no data is arriving: that's
      // STATUS_OFF/EMPTY/WRONG *and* STATUS_DISABLED_BY_TARIFF (20) — the last one used to
      // slip through the old truthiness check and left a billing-disabled bot looking fine.
      const status = this.currentBotStatus
      const connected = status === STATUS_ON || status === STATUS_CONNECTING
      return !this.$store.getters['init/getHasDemobot'] && !!this.current_bot && !connected
    }
  }
}
</script>
